import { render, staticRenderFns } from "./DiscountItem.vue?vue&type=template&id=5f9080a6"
import script from "./DiscountItem.vue?vue&type=script&lang=js"
export * from "./DiscountItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports